import React from 'react';
import styles from './NotificationStack.module.css';
import {
  HiCheckCircle, HiXCircle, HiInformationCircle
} from 'react-icons/hi2';

const icons = {
  success: <HiCheckCircle />,
  error: <HiXCircle />,
  info: <HiInformationCircle />
};

export default function NotificationStack({ messages }) {
  if(messages.length <= 0) return null;
  return (
    <div key={messages[0]?.id} className={styles.stack}>
      {messages.map(({ id, type, content }) => (
        <div key={id} className={`${styles.toast} ${styles[type]}`}>
          <span className={styles.icon}>{icons[type]}</span>
          <span className={styles.toasttext}>{content}</span>
        </div>
      ))}
    </div>
  );
}
